/*!
 *
 * sort.js
 *
 */

var data = require('senior');

var loaded = false;
var filter = [];
var $sort = $('#sort');
var $sortIndex = $('#sortIndex');
var $seniorLoading = $('#seniorLoading');
var $reset = $('#sortReset');

var imgLoad = function(src){
	var d = new $.Deferred;
	var $img = $('<img />');
	$img.attr('src', src).on('load', function(){
		d.resolve();
	});
	return d.promise();
};

var setEvent = function(){
	var $input = $sort.find('input');

	$input.on('change', setFilter);

	$reset.on('tap', function(e){
		e.preventDefault();
		$input.prop('checked', false);
		setFilter();
	});
};

var $year = $sort.find('input[name="year"]');
var $affili = $sort.find('input[name="affili"]');
var $kind = $sort.find('input[name="kind"]');
var setFilter = function(){

	filter = [];

	var _year = [];
	$year.filter(function(){
		return $(this).is(':checked');
	}).each(function(){
		_year.push('.year' + $(this).val());
	});

	var _affili = [];
	$affili.filter(function(){
		return $(this).is(':checked');
	}).each(function(){
		_affili.push('.affili' + $(this).val());
	});

	var _kind = [];
	$kind.filter(function(){
		return $(this).is(':checked');
	}).each(function(){
		_kind.push('.kind' + $(this).val());
	});

	var i = 0;
	do {
		var __year = '';
		if( _year[i] ){
			__year = _year[i];
		};
		var j = 0;
		do {
			var __affili = '';
			if( _affili[j] ){
				__affili = _affili[j];
			};
			var k = 0;
			do {
				var __kind = '';
				if( _kind[k] ){
					__kind = _kind[k];
				};
				var temp = __year+__affili+__kind;
				if( temp !== '' ){
					filter.push(temp);
				};
				k++;
			} while( k<_kind.length );
			j++;
		} while( j<_affili.length );
		i++;
	} while( i<_year.length );

	if( loaded ){
		var _filter = filter.join('');
		if( $(_filter).length === 0 && filter.length !== 0 ){
			_filter = '.empty';
		};
		if( filter.length === 0 ){
			_filter = '.year1,.year2,.year3,.affili1,.affili2,.affili3,.affili4,.kind1,.kind2,.kind3';
		};
		$sortIndex.isotope({
			filter: _filter
		});
		$sortIndex.isotope();
	};
};

var createGrid = function(){
	data = _.shuffle(data);

	var imgs = [];
	var temp = '';

	var max = $sortIndex.data('max');
	var without = $sortIndex.data('without');
	if( max === undefined ){
		max = data.length;
	};

	_.each(data, function(val, key){
		if( key < max ){
			if( val.id !== without ){
				imgs.push( '/jinji/img/company/senior/'+ val.id +'_index.jpg' );
				var _class = '';
				_class = ' year' + val.year + ' affili' + val.affili + ' kind' + val.kind;
				temp += '<li class="senior-Index_Item'+ _class +'">'+
							'<a href="/jinji/company/senior/'+ val.id +'.html" class="senior-Index_Link">'+
								'<img src="/jinji/img/company/senior/'+ val.id +'_index.jpg" alt="" class="senior-Index_Img">'+
								'<div class="senior-Index_Label">'+
									'<h3 class="senior-Index_Label_Title">'+ val.name +'</h3>'+
									'<p class="senior-Index_Label_Affili">'+ val.department +'</p>'+
								'</div>'+
							'</a>'+
						'</li>';
			}else{
				max++;
			};
		};
	});

	var max = imgs.length;
	_.each(imgs, function(val, i){
		var promise = imgLoad(val);
		promise.done(function(){
		if( --max > 0 ) return false;
			$sortIndex.append(temp);

			var _filter = filter.join('');
			if( $(_filter).length === 0 && filter.length !== 0 ){
				_filter = '.empty';
			};
			if( filter.length === 0 ){
				_filter = '.year1,.year2,.year3,.affili1,.affili2,.affili3,.affili4,.kind1,.kind2,.kind3';
			};
			$sortIndex.isotope({
				itemSelector: '.senior-Index_Item',
				percentPosition: true,
				filter: _filter,
				masonry: {
					gutter: '.senior-Index_Gutter'
				}
			});
			$seniorLoading.fadeOut(1000, function(){
				loaded = true;
			});
		});
	});
};




module.exports = function(){
	setEvent();
	createGrid();
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/sort.js
// module id = 21
// module chunks = 0